// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pd-8";
export var editMode = "_pd-3";
export var headerRow = "_pd-a";
export var headerTitle = "_pd-b";
export var product = "_pd-1";
export var productDetails = "_pd-5";
export var productDivider = "_pd-7";
export var productImage = "_pd-2";
export var productInfo = "_pd-4";
export var productTitle = "_pd-6";
export var strikethrough = "_pd-9";
export var upsellProductsCard = "_pd-0";